import styled from 'styled-components'
import { Dialog } from '@material-ui/core'
import { colors, StyledButton } from '../../../theme/Global'

export const StyledDialog = styled(Dialog)`
  width: 100%;
  maxWidth: none;
`

export const CustomErrorMessage = styled.div`
  background: ${colors.white};
  border-left: 1rem solid ${colors.govDocsRed};
  box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
  margin: 0 auto;
  padding: 1rem;
  min-width: 350px;
}`

export const ErrorLoginButton = styled(StyledButton)`
  margin: 0.3rem 0 !important;
  float: right;
`
